const searchBarCompanies = {
  placeholder: 'Ingresá una empresa',
  autocomplete: 'Ingresá al menos {{caracteres}} caracteres',
}

export default searchBarCompanies
